module.exports = __webpack_public_path__ + "static/media/Position_10m.3b783454.jpg";